import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-label-with-tooltip"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.tooltip)?_c(VTooltip,{attrs:{"max-width":"250px","open-delay":"300","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,_vm._g(_vm._b({staticClass:"input-label-tooltip-icon ml-1",attrs:{"color":"primary","small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-information-outline ")])]}}],null,false,4142751059)},[_c('span',{staticClass:"white--text",staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }